// extracted by css-extract-rspack-plugin
export default {"placeholderClass":"_c80ea34d"};